/* Nesti — avaliações da PDP: mural (coluna mais curta primeiro, como o app), Load more de 5 em 5,
   ordenação, Read more, foto ampliada com setas, formulário Write a review (formulário de contato). */
(function () {
  function colunas() { return innerWidth < 750 ? 2 : 4; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function iniciar(raiz) {
    if (raiz.dataset.pronto) return; raiz.dataset.pronto = '1';
    var mural = raiz.querySelector('[data-nesti-lg-mural]');
    var modelo = mural.querySelector('.nesti-lg__item');
    var ESTRELA = modelo ? modelo.querySelector('.nesti-lg__estrela').innerHTML : '';
    var numFoto = modelo && modelo.parentNode.querySelector('.nesti-lg__num svg');
    var FOTO = numFoto ? numFoto.outerHTML : '';
    var bandeira = raiz.dataset.bandeira;
    var porVez = +raiz.dataset.porVez || 5, total = +raiz.dataset.total || 0;
    var iniciais = []; try { iniciais = JSON.parse(raiz.querySelector('[data-nesti-lg-iniciais]').textContent); } catch (e) {}
    var todos = null, lista = iniciais, mostrados = mural.querySelectorAll('.nesti-lg__item').length, ordem = 'date';
    var botaoMais = raiz.querySelector('[data-nesti-lg-mais]');

    function cartao(r) {
      var longo = !!r.curto, fotos = r.fotos || [];
      var h = '<div class="nesti-lg__item' + (fotos.length ? ' tem-foto' : '') + '" role="article" aria-label="Review by ' + esc(r.nome) + ', ' + r.nota + ' out of 5" data-id="' + r.id + '">';
      if (fotos.length) h += '<div class="nesti-lg__thumb" data-fotos="' + esc(fotos.join('|')) + '"><img src="' + fotos[0] + (fotos[0].indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy" width="257" height="260"><span class="nesti-lg__num">' + fotos.length + FOTO + '</span></div>';
      h += '<div class="nesti-lg__conteudo"><div class="nesti-lg__estrelas"><div class="nesti-lg__selo" role="img" aria-label="' + r.nota + ' out of 5">';
      for (var i = 1; i <= 5; i++) h += '<span class="nesti-lg__estrela' + (i > r.nota ? ' vazia' : '') + '">' + ESTRELA + '</span>';
      h += '</div></div><div class="nesti-lg__autor"><span class="nesti-lg__avatar">' + esc(r.nome.charAt(0).toUpperCase()) + '</span><span class="nesti-lg__nome">' + esc(r.nome) + '</span>';
      if (r.pais) h += '<span class="nesti-lg__flag" style="background-image:url(' + bandeira.replace('nesti-flag-xx.svg', 'nesti-flag-' + r.pais + '.svg') + ')"></span>';
      h += '</div>';
      if (longo) h += '<div class="nesti-lg__texto nesti-lg__texto--curto">' + esc(r.curto) + '...<span class="nesti-lg__ler" role="button" tabindex="0">Read more</span></div><div class="nesti-lg__texto nesti-lg__texto--longo" hidden>' + esc(r.texto) + '</div>';
      else h += '<div class="nesti-lg__texto">' + esc(r.texto) + '</div>';
      h += '<div class="nesti-lg__data"><time>' + esc(r.data) + '</time></div></div></div>';
      var d = document.createElement('div'); d.innerHTML = h; return d.firstChild;
    }
    // mural: cada cartão vai para a coluna mais curta (o app posiciona assim)
    var seq = 0;
    function arrumar() {
      // a ordem é a da lista (guardada em cada cartão), nunca a ordem das colunas da arrumação anterior
      var itens = Array.prototype.slice.call(mural.querySelectorAll('.nesti-lg__item'));
      itens.forEach(function (it) { if (!it.dataset.ordemI) it.dataset.ordemI = String(seq++); });
      itens.sort(function (a, b) { return +a.dataset.ordemI - +b.dataset.ordemI; });
      mural.innerHTML = ''; mural.classList.add('is-pronto');
      var n = colunas(), cols = [];
      for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'nesti-lg__coluna'; mural.appendChild(c); cols.push(c); }
      itens.forEach(function (it) {
        var menor = cols.reduce(function (a, b) { return b.offsetHeight < a.offsetHeight ? b : a; });
        menor.appendChild(it);
      });
    }
    function carregarTodos() {
      if (todos) return Promise.resolve(todos);
      return fetch(raiz.dataset.acervo).then(function (r) { return r.json(); }).then(function (j) { todos = j; return j; });
    }
    function ordenar(l) {
      var c = l.slice();
      if (ordem === 'content') c.sort(function (a, b) { return b.texto.length - a.texto.length; });
      if (ordem === 'photo') c.sort(function (a, b) { return (b.fotos || []).length - (a.fotos || []).length; });
      if (ordem === 'rating') c.sort(function (a, b) { return b.nota - a.nota; });
      return c;
    }
    function mostrarAte(qtd) {
      var itens = Array.prototype.slice.call(mural.querySelectorAll('.nesti-lg__item'));
      itens.forEach(function (it) { it.remove(); });
      mural.querySelectorAll('.nesti-lg__coluna').forEach(function (c) { c.remove(); });
      seq = 0;
      lista.slice(0, qtd).forEach(function (r) { mural.appendChild(cartao(r)); });
      mostrados = Math.min(qtd, lista.length);
      arrumar();
      if (botaoMais) botaoMais.parentNode.hidden = mostrados >= total;
    }
    if (botaoMais) botaoMais.addEventListener('click', function () {
      var alvo = mostrados + porVez;
      if (alvo <= lista.length && (todos || lista.length >= alvo)) { mostrarAte(alvo); return; }
      carregarTodos().then(function (t) { lista = ordenar(t); mostrarAte(alvo); });
    });
    // ordenação
    var titulo = raiz.querySelector('.nesti-lg__ordem-titulo'), ul = raiz.querySelector('.nesti-lg__ordem-lista');
    titulo.addEventListener('click', function () { ul.hidden = !ul.hidden; titulo.setAttribute('aria-expanded', String(!ul.hidden)); });
    ul.addEventListener('click', function (e) {
      var li = e.target.closest('li'); if (!li) return;
      ordem = li.dataset.ordem; ul.hidden = true; titulo.setAttribute('aria-expanded', 'false');
      ul.querySelectorAll('li').forEach(function (x) { x.classList.toggle('is-on', x === li); });
      carregarTodos().then(function (t) { lista = ordenar(t); mostrarAte(Math.max(porVez, mostrados)); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.nesti-lg__ordem')) ul.hidden = true; });
    // Read more, fotos
    raiz.addEventListener('click', function (e) {
      var ler = e.target.closest('.nesti-lg__ler');
      if (ler) { var it = ler.closest('.nesti-lg__item'); it.querySelector('.nesti-lg__texto--curto').hidden = true; it.querySelector('.nesti-lg__texto--longo').hidden = false; arrumar(); return; }
      var alvo = e.target.closest('[data-fotos]');
      if (alvo) abrirFotos(alvo.getAttribute('data-fotos').split('|'));
    });
    function abrirFotos(fotos) {
      var i = 0, cam = document.createElement('div'); cam.className = 'nesti-lg-foto';
      cam.innerHTML = '<img alt=""><button type="button" class="fechar" aria-label="Close">×</button>' + (fotos.length > 1 ? '<button type="button" class="ant" aria-label="Previous">‹</button><button type="button" class="prox" aria-label="Next">›</button>' : '');
      var img = cam.querySelector('img');
      function ver() { img.src = fotos[i] + (fotos[i].indexOf('?') > -1 ? '&' : '?') + 'width=1600'; }
      function fechar() { cam.remove(); document.removeEventListener('keydown', tecla); }
      function tecla(k) { if (k.key === 'Escape') fechar(); if (k.key === 'ArrowRight') { i = (i + 1) % fotos.length; ver(); } if (k.key === 'ArrowLeft') { i = (i - 1 + fotos.length) % fotos.length; ver(); } }
      cam.addEventListener('click', function (e) {
        if (e.target.classList.contains('prox')) { i = (i + 1) % fotos.length; ver(); return; }
        if (e.target.classList.contains('ant')) { i = (i - 1 + fotos.length) % fotos.length; ver(); return; }
        if (e.target === cam || e.target.classList.contains('fechar')) fechar();
      });
      document.addEventListener('keydown', tecla); ver(); document.body.appendChild(cam);
    }
    // Write a review: abre o formulário (vai pelo formulário de contato da loja) e as estrelas escolhem a nota
    var form = raiz.querySelector('.nesti-lg__form');
    raiz.querySelector('[data-nesti-lg-escrever]').addEventListener('click', function () { form.hidden = !form.hidden; });
    if (location.search.indexOf('contact_posted=true') > -1 || form.querySelector('.nesti-lg__obrigado')) form.hidden = false;
    var campoNota = form.querySelector('[data-nesti-lg-nota]');
    form.querySelectorAll('[data-nota]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = +b.dataset.nota; campoNota.value = n;
        form.querySelectorAll('[data-nota]').forEach(function (x) { x.classList.toggle('is-on', +x.dataset.nota <= n); });
      });
    });
    var larg = innerWidth; window.addEventListener('resize', function () { if ((innerWidth < 750) !== (larg < 750)) { larg = innerWidth; arrumar(); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(arrumar);
    arrumar();
    window.addEventListener('load', arrumar);
  }
  function tudo() { document.querySelectorAll('[data-nesti-lg]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
  document.addEventListener('shopify:section:load', tudo);
})();
